export default __webpack_public_path__ + "unicode.arialr.b5470060.ttf";